import { createActionName } from 'utils/actions.util';

class Actions {
  prefix = '[LOCALES]';

  INITIALIZE_LOCALE = createActionName(this.prefix, 'INITIALIZE_LOCALE');

  SWITCH_LOCALE = createActionName(this.prefix, 'SWITCH_LOCALE');

  SELECT_LOCALE = createActionName(this.prefix, 'SELECT_LOCALE');

  UPDATE_ACTIVATED_ROUTE_ID = createActionName(
    this.prefix,
    'UPDATE_ACTIVATED_ROUTE'
  );

  LOAD_DYNAMIC_MESSAGES = createActionName(
    this.prefix,
    'LOAD_DYNAMIC_MESSAGES'
  );

  initializeLocale = () => ({
    type: this.INITIALIZE_LOCALE,
  });

  switchLocale = () => ({
    type: this.SWITCH_LOCALE,
  });

  selectLocale = selectedLocale => ({
    type: this.SELECT_LOCALE,
    selectedLocale,
  });

  updateActivatedRouteId = routeId => ({
    type: this.UPDATE_ACTIVATED_ROUTE_ID,
    routeId,
  });

  loadDynamicMessages = (key, messages) => ({
    type: this.LOAD_DYNAMIC_MESSAGES,
    payload: { key, messages },
  });
}

export default new Actions();
